import { TaskList } from "./TaskList";

export default {
  list: TaskList,
};
